import { all, fork } from 'redux-saga/effects'

import reporter from '../reporting/reporter'

import ReportingSaga from './ReportingSaga'

export default function* reportingSagas() {
  yield all([fork(new ReportingSaga({ reporter }).supervise)])
}
